/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AnnuallyConfig } from '../models/AnnuallyConfig';
import { DailyConfig } from '../models/DailyConfig';
import { HighFrequencyBackupScheduleFrequency } from '../models/HighFrequencyBackupScheduleFrequency';
import { HighFrequencyIntervalConfig } from '../models/HighFrequencyIntervalConfig';
import { MonthlyConfig } from '../models/MonthlyConfig';
import { WeeklyConfig } from '../models/WeeklyConfig';

export class HighFrequencyBackupScheduleConfig {
  'frequency'?: HighFrequencyBackupScheduleFrequency;
  'intervalConfig'?: HighFrequencyIntervalConfig | null;
  'dailyConfig'?: DailyConfig | null;
  'weeklyConfig'?: WeeklyConfig | null;
  'monthlyConfig'?: MonthlyConfig | null;
  'annuallyConfig'?: AnnuallyConfig | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "frequency",
      "baseName": "frequency",
      "type": "HighFrequencyBackupScheduleFrequency",
      "format": ""
    },
    {
      "name": "intervalConfig",
      "baseName": "intervalConfig",
      "type": "HighFrequencyIntervalConfig",
      "format": ""
    },
    {
      "name": "dailyConfig",
      "baseName": "dailyConfig",
      "type": "DailyConfig",
      "format": ""
    },
    {
      "name": "weeklyConfig",
      "baseName": "weeklyConfig",
      "type": "WeeklyConfig",
      "format": ""
    },
    {
      "name": "monthlyConfig",
      "baseName": "monthlyConfig",
      "type": "MonthlyConfig",
      "format": ""
    },
    {
      "name": "annuallyConfig",
      "baseName": "annuallyConfig",
      "type": "AnnuallyConfig",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return HighFrequencyBackupScheduleConfig.attributeTypeMap;
  }

  public constructor() {
  }
}



